import React from 'react';

const AboutHeroIllustration: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Abstract illustration combining the scales of justice with data orbits"
    fill="none"
  >
    <defs>
      <radialGradient id="jt-core-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#c9a84c" stopOpacity="0.45" />
        <stop offset="55%" stopColor="#c9a84c" stopOpacity="0.08" />
        <stop offset="100%" stopColor="#c9a84c" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="jt-gold-line" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#e8d08a" />
        <stop offset="100%" stopColor="#a8832a" />
      </linearGradient>
      <linearGradient id="jt-diamond-fill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#c9a84c" stopOpacity="0.25" />
        <stop offset="100%" stopColor="#c9a84c" stopOpacity="0.05" />
      </linearGradient>
    </defs>

    <circle cx="250" cy="250" r="200" fill="url(#jt-core-glow)" />

    <circle
      cx="250"
      cy="250"
      r="215"
      stroke="#c9a84c"
      strokeOpacity="0.14"
      strokeWidth="1"
      strokeDasharray="2 7"
    />
    <circle
      cx="250"
      cy="250"
      r="165"
      stroke="#c9a84c"
      strokeOpacity="0.22"
      strokeWidth="1"
    />
    <circle
      cx="250"
      cy="250"
      r="115"
      stroke="#c9a84c"
      strokeOpacity="0.3"
      strokeWidth="1"
      strokeDasharray="3 5"
    />

    <line
      x1="250"
      y1="150"
      x2="250"
      y2="350"
      stroke="url(#jt-gold-line)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <line
      x1="125"
      y1="230"
      x2="375"
      y2="230"
      stroke="url(#jt-gold-line)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />

    <path
      d="M 125 230 Q 125 270 150 275 Q 175 270 175 230 Z"
      stroke="#c9a84c"
      strokeOpacity="0.55"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <line
      x1="125"
      y1="230"
      x2="150"
      y2="220"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <line
      x1="175"
      y1="230"
      x2="150"
      y2="220"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <circle cx="150" cy="275" r="2" fill="#e8d08a" />

    <path
      d="M 325 230 Q 325 270 350 275 Q 375 270 375 230 Z"
      stroke="#c9a84c"
      strokeOpacity="0.55"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <line
      x1="325"
      y1="230"
      x2="350"
      y2="220"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <line
      x1="375"
      y1="230"
      x2="350"
      y2="220"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <circle cx="350" cy="275" r="2" fill="#e8d08a" />

    <path
      d="M 250 205 L 272 250 L 250 295 L 228 250 Z"
      fill="url(#jt-diamond-fill)"
      stroke="url(#jt-gold-line)"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <circle cx="250" cy="250" r="3.5" fill="#e8d08a" />

    <line
      x1="215"
      y1="355"
      x2="285"
      y2="355"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="250"
      y1="350"
      x2="250"
      y2="370"
      stroke="#c9a84c"
      strokeOpacity="0.4"
      strokeWidth="1"
    />

    <line
      x1="250"
      y1="150"
      x2="250"
      y2="130"
      stroke="#c9a84c"
      strokeOpacity="0.5"
      strokeWidth="1"
    />
    <circle cx="250" cy="125" r="3" fill="#e8d08a" />

    <circle cx="415" cy="200" r="2.5" fill="#c9a84c" />
    <circle cx="90" cy="295" r="2" fill="#c9a84c" />
    <circle cx="385" cy="395" r="2" fill="#e8d08a" opacity="0.7" />
    <circle cx="115" cy="120" r="2.5" fill="#e8d08a" opacity="0.7" />
    <circle cx="440" cy="310" r="1.6" fill="#c9a84c" opacity="0.55" />
    <circle cx="60" cy="200" r="1.6" fill="#c9a84c" opacity="0.55" />
    <circle cx="320" cy="60" r="1.8" fill="#e8d08a" opacity="0.6" />
    <circle cx="180" cy="440" r="1.8" fill="#c9a84c" opacity="0.5" />

    <line
      x1="70"
      y1="250"
      x2="88"
      y2="250"
      stroke="#c9a84c"
      strokeOpacity="0.3"
      strokeWidth="1"
    />
    <line
      x1="412"
      y1="250"
      x2="430"
      y2="250"
      stroke="#c9a84c"
      strokeOpacity="0.3"
      strokeWidth="1"
    />
  </svg>
);

export default AboutHeroIllustration;
